export enum TabsEnum {
  APPROVALS = 1,
  MY_CONTRIBUTIONS = 2,
  DEACTIVATED_AUTOMATIONS = 3,
}
